import { getHttpClient } from './httpClient';

export interface Conversation {
  id: number;
  enterprise_id: string;
  user_id: string;
  user_locale: string;
  subject: string;
  subject_fr: string | null;
  category: string | null;
  problem_id: number | null;
  status: string;
  created_at: string;
  updated_at: string;
  user_email?: string;
  first_name?: string;
  last_name?: string;
  enterprise_name?: string;
}

export interface MessageImage {
  id: string;
  data: string;
  alt?: string;
}

export interface Message {
  id: number;
  conversation_id: number;
  sender_type: 'user' | 'support';
  sender_id: string | null;
  original_text: string;
  original_locale: string;
  translated_text: string | null;
  images: MessageImage[];
  created_at: string;
}

export async function listConversations(): Promise<{ conversations: Conversation[]; openCount: number }> {
  const { data } = await getHttpClient().get('/api/admin/support/conversations');
  return data;
}

export async function getOpenCount(): Promise<number> {
  const { data } = await getHttpClient().get('/api/admin/support/conversations/count');
  return data.count;
}

export async function getConversation(id: number): Promise<{ conversation: Conversation; messages: Message[] }> {
  const { data } = await getHttpClient().get(`/api/admin/support/conversations/${id}`);
  return data;
}

export async function sendMessage(conversationId: number, message: string): Promise<Message> {
  const { data } = await getHttpClient().post<Message>(`/api/admin/support/conversations/${conversationId}/messages`, { message });
  return data;
}

export async function updateStatus(conversationId: number, status: string): Promise<Conversation> {
  const { data } = await getHttpClient().patch<Conversation>(`/api/admin/support/conversations/${conversationId}/status`, { status });
  return data;
}

export async function getSettings(): Promise<Record<string, string>> {
  const { data } = await getHttpClient().get('/api/admin/support/settings');
  return data;
}

export async function saveSettings(
  targetEnterpriseId: string,
  targetTeamId: string,
  feedbackBugChartId?: number | null,
  feedbackNpsChartId?: number | null,
): Promise<void> {
  const payload: Record<string, unknown> = {
    target_enterprise_id: targetEnterpriseId,
    target_team_id: targetTeamId,
  };
  if (feedbackBugChartId !== undefined) {
    payload.feedback_bug_chart_id = feedbackBugChartId;
  }
  if (feedbackNpsChartId !== undefined) {
    payload.feedback_nps_chart_id = feedbackNpsChartId;
  }
  await getHttpClient().put('/api/admin/support/settings', payload);
}

export interface LeanChartSummary {
  id: number;
  uuid: string;
  name: string;
  type: string | null;
  periodicity: string | null;
}

export async function listChartsByTeam(teamId: string): Promise<LeanChartSummary[]> {
  const { data } = await getHttpClient().get<LeanChartSummary[]>(`/api/admin/charts/by-team/${teamId}`);
  return data;
}
